import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

// API
import { api } from 'api/baseQuery'

// Slices
import alert from 'components/alert/alertSlice'
import authentication from 'store/authenticationSlice'
import destress from 'pages/destress/components/destressSlice'
import filter from 'components/filter/filterSlice'
import goal from 'pages/goals/goalSlice'
import history from './historySlice'
import modal from 'components/modals/modalSlice'
import onboarding from 'pages/onboarding/components/onboardingSlice'
import priorities from 'pages/dashboard/components/priorities/prioritiesSlice'
import school from 'components/school/schoolSlice'
import search from 'pages/search/searchSlice'
import sidebar from 'components/sidebar/sidebarSlice'
import spotlight from 'components/spotlight/spotlightSlice'
import theme from './themeSlice'
import user from './userSlice'

const reducer = {
  alert,
  authentication,
  destress,
  filter,
  goal,
  history,
  modal,
  onboarding,
  priorities,
  school,
  search,
  sidebar,
  spotlight,
  theme,
  user,
  [api.reducerPath]: api.reducer
}

export const middleware = getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false
  }).concat(api.middleware)

export const store = configureStore({
  middleware,
  reducer
})

setupListeners(store.dispatch)
